import React, { useEffect, useState } from "react";
import { useLiveKit } from "../hooks";
import { LiveKitTrack } from "./track";
import { BroadcasterError } from "../consts";
import { logToGraylog } from "core/stores";
import { logger } from "library/core/utility";

type LiveKitPlayerProps = {
  memberName: string;
  onSuccess: () => void;
  onFail: (error: any) => void;
  onDisconnect: () => void;
};

export const LiveKitPlayer: React.FC<LiveKitPlayerProps> = ({
  memberName,
  onSuccess,
  onDisconnect,
  onFail,
}) => {
  const [isMuted, setIsMuted] = useState(false);
  const { hostTracks, error, participants, connect, disconnect } = useLiveKit();

  const start = async () => {
    try {
      logger.log("[Livekit] Starting livekit cam2cam", {
        memberName,
        participants,
      });
      logToGraylog("[Livekit]", "Starting livekit cam2cam", {
        memberName,
        participants,
      });
      await connect();
    } catch {
      onFail(BroadcasterError.ErrorStartingBroadcast);
    }
  };

  const leave = async () => {
    logger.log("[Livekit] Leaving livekit cam2cam", {
      memberName,
      participants,
    });
    logToGraylog("[Livekit]", "Leaving livekit cam2cam", {
      memberName,
      participants,
    });
    await disconnect();
    onDisconnect();
  };

  useEffect(() => {
    start();
    return () => {
      leave();
    };
  }, []);

  useEffect(() => {
    if (error) {
      logger.log("[Livekit] Error in livekit cam2cam", {
        memberName,
        participants,
        error,
      });
      logToGraylog("[Livekit]", "Error in livekit cam2cam", {
        memberName,
        participants,
        error,
      });
      onFail(error);
    }
  }, [error]);

  useEffect(() => {
    if (hostTracks?.length) {
      logger.log("[Livekit] Successfully got host tracks", {
        memberName,
        participants,
        hostTracks,
      });
      logToGraylog("[Livekit]", "Successfully got host tracks", {
        memberName,
        participants,
        hostTracks,
      });
      onSuccess();
    }
  }, [hostTracks]);

  if (!hostTracks?.length) {
    return null;
  }

  return (
    <div className='BroadcastC2CRTCViewer m-3'>
      <LiveKitTrack volume={isMuted ? 0 : 1} tracks={hostTracks} />
      <div className='BroadcastC2CRTCViewer__info'>
        <span>{memberName}</span>
        <span className='BroadcastC2CRTCViewer__flex'></span>
        <span
          onClick={() => setIsMuted(!isMuted)}
          className='BroadcastC2CRTCViewer__icon material-icons'>
          {isMuted ? "volume_off" : "volume_up"}
        </span>
      </div>
    </div>
  );
};
